var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenhouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(12 12)",
    fill: "#24A57F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23507_259744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6741 20.9568C26.6741 21.6811 26.3677 22.3217 25.8663 22.8231C25.3092 23.3802 24.5014 23.5195 24.5014 23.993C24.5014 24.6337 25.532 24.4387 26.5209 25.4276C27.1755 26.0822 27.5794 26.9457 27.5794 27.9485C27.5794 29.9262 25.9916 31.5 24 31.5C22.0083 31.5 20.4206 29.9262 20.4206 27.9485C20.4206 26.9457 20.8245 26.0822 21.4791 25.4276C22.4679 24.4387 23.4986 24.6337 23.4986 23.993C23.4986 23.5195 22.6908 23.3802 22.1337 22.8231C21.6323 22.3217 21.3259 21.6811 21.3259 20.929C21.3259 19.4805 22.5097 18.3106 23.9582 18.3106C24.2367 18.3106 24.4874 18.3524 24.6964 18.3524C25.0724 18.3524 25.2674 18.1852 25.2674 17.9206C25.2674 17.7674 25.1978 17.5724 25.1978 17.3635C25.1978 16.89 25.6017 16.5 26.0891 16.5C26.5766 16.5 26.9666 16.9039 26.9666 17.3914C26.9666 17.9067 26.5627 18.1435 26.2562 18.2549C26.0056 18.3384 25.8106 18.4499 25.8106 18.7006C25.8106 19.1741 26.6741 19.6337 26.6741 20.9568ZM26.3955 27.9485C26.3955 26.5696 25.3788 25.4554 24 25.4554C22.6212 25.4554 21.6044 26.5696 21.6044 27.9485C21.6044 29.3134 22.6212 30.4415 24 30.4415C25.3788 30.4415 26.3955 29.3134 26.3955 27.9485ZM25.5738 20.929C25.5738 20.0515 24.8635 19.3273 24 19.3273C23.1365 19.3273 22.4262 20.0515 22.4262 20.929C22.4262 21.8064 23.1365 22.5306 24 22.5306C24.8635 22.5306 25.5738 21.8064 25.5738 20.929Z",
    fill: "#FEFDFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23507_259744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.15877,
    height: 15,
    fill: "white",
    transform: "translate(20.4206 16.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenhouse);
export default __webpack_public_path__ + "static/media/Greenhouse.c61cf308b42df12fa24299f2ec4f1af7.svg";
export { ForwardRef as ReactComponent };